import { render } from "./AdminNav.vue?vue&type=template&id=22e4585a"
import script from "./AdminNav.vue?vue&type=script&lang=js"
export * from "./AdminNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__